import React from "react";
import { CustomPicker } from "react-color";
import { Saturation } from "react-color/lib/components/common";
import { useSelector } from "react-redux";
import { getDir } from "orion-components/i18n/Config/selector";

const Pointer = () => {
	const dir = useSelector((state) => getDir(state));
	return (
		<div
			style={{
				...(dir === "ltr" && { marginLeft: 2 }),
				...(dir === "rtl" && { marginRight: 2 }),
				width: "10px",
				height: "10px",
				boxShadow:
					"rgb(255, 255, 255) 0px 0px 0px 1.5px, rgba(0, 0, 0, 0.3) 0px 0px 1px 1px inset, rgba(0, 0, 0, 0.4) 0px 0px 1px 2px",
				borderRadius: "50%",
				transform: "translate(-2px, -2px)"
			}}
		></div>
	);
};

const CustomSaturation = (props) => {
	return (
		<div>
			<Saturation {...props} pointer={Pointer} />
		</div>
	);
};

export default CustomPicker(CustomSaturation);
